import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { CreatorList } from 'src/lib/entity/live'
import { AdminPointPlan } from 'src/lib/entity/manage-point'

@Injectable({ providedIn: 'root' })
export class CommonService {
  private creatorData$: BehaviorSubject<Array<CreatorList>> =
    new BehaviorSubject([])
  creatorlist = this.creatorData$.asObservable()

  private adminPointPlan$: BehaviorSubject<any> = new BehaviorSubject({})
  pointPlan = this.adminPointPlan$.asObservable()

  private authorityData$: BehaviorSubject<any> = new BehaviorSubject({})
  authority = this.authorityData$.asObservable()

  private maintenanceData$: BehaviorSubject<any> = new BehaviorSubject({})
  maintenanceInfo = this.maintenanceData$.asObservable()

  private configData$: BehaviorSubject<any> = new BehaviorSubject({})
  configSetting = this.configData$.asObservable()
  constructor() {}

  setCreatorList(data: Array<CreatorList>) {
    this.creatorData$.next(data)
  }

  setPointPlan(data: AdminPointPlan) {
    this.adminPointPlan$.next(data)
  }

  setAuthority(data: any) {
    this.authorityData$.next(data)
  }

  setMaintenanceData(data: any) {
    this.maintenanceData$.next(data)
  }

  setConfigData(data: any) {
    this.configData$.next(data)
  }
}
